import { BRAND, IS_DEMO } from '@/lib/brand'
type Props = {
  /** Texto opcional debajo del isotipo. */
  label?: string
  /** Tamaño del isotipo en px. Default 56 inline, 80 fullscreen. */
  size?: number
  /** Si true, ocupa toda la pantalla con bg blanco. */
  fullscreen?: boolean
}

/**
 * Loading state oficial de NeoCore — isotipo naranja girando suave.
 * Reemplaza spinners genéricos en momentos donde queremos comunicar
 * "está pasando algo importante" (login, cargas iniciales, splash).
 */
export function LoadingNeocoop({ label, size, fullscreen = false }: Props) {
  const finalSize = size ?? (fullscreen ? (IS_DEMO ? 150 : 80) : 56)
  const wrapStyle: React.CSSProperties = fullscreen
    ? {
        position: 'fixed',
        inset: 0,
        background: IS_DEMO ? 'var(--tenant-primario)' : 'var(--bg)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 18,
      }
    : {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        padding: 24,
      }

  return (
    <div style={wrapStyle} role="status" aria-live="polite">
      <img
        src={IS_DEMO ? (fullscreen ? BRAND.isoSobreColor : BRAND.isoClaro) : '/brand/isotipo-naranja.svg'}
        alt=""
        aria-hidden="true"
        className="loading-iso-spin"
        style={{ width: finalSize, height: finalSize }}
      />
      {label && (
        <p
          style={{
            fontSize: 13,
            color: IS_DEMO && fullscreen ? '#ffffff' : 'var(--text-muted)',
            fontWeight: 500,
            margin: 0,
            letterSpacing: 0.2,
          }}
        >
          {label}
        </p>
      )}
    </div>
  )
}
